const KDD = [
    {id: "0", value: "日K"},    
    {id: "1", value: "日D"}   
  ];  
  
  export default KDD